import { useDataValue } from 'Simple/Data'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let location_id = useDataValue({
    context: 'selected',
    path: 'location_id',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    if (!value.name) return true
    if (value.is_included_in_insurance_claim && !value.insurance_code_id) {
      notify(
        notifyError(
          `Please select an insurance code for charges included in claims.`
        )
      )
      return true
    }

    let mutationResponse = await executeMutation({
      object: {
        name: value.name,
        price: value.price,
        insurance_code_id: value.insurance_code_id,
        affecting_production_report: value.affecting_production_report,
        is_included_in_insurance_claim: value.is_included_in_insurance_claim,
        requires_tooth_details: value.requires_tooth_details,
        organization_id: location_id,
        procedure_misc_fee_charge_templates: {
          data: value.procedure_ids.map(procedure_id => ({
            procedure_id,
          })),
        },
      },
    })
    if (mutationResponse.error) {
      notify(notifyError(`An error has occurred while inserting charge.`))
      return
    }

    notify(notifySuccess(`New charge has been added.`))

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
